import React from 'react';
import ReactDOM from 'react-dom';
import {LayerContext} from '../contexts/layer-context';
import {LayerResult} from '../utils/use-layer';

export interface LayerPortalProps {
  readonly layerResult: LayerResult;
  children: React.ReactNode;
}

export function LayerPortal({
  layerResult,
  children,
}: LayerPortalProps): JSX.Element | null {
  React.useEffect(
    () => () => {
      if (layerResult.isOpen) {
        layerResult.close();
      }
    },
    [layerResult]
  );

  if (!layerResult.isOpen) {
    return null;
  }

  return (
    <LayerContext.Provider value={layerResult}>
      {ReactDOM.createPortal(children, layerResult.mountPoint)}
    </LayerContext.Provider>
  );
}
